<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          label-placeholder="Title"
          v-model="message.title"
          v-on:input="onUpdate"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-textarea
          label="Message Body (optional)"
          v-model="message.message"
          v-on:input="onUpdate"
          class="w-full"
        />
      </div>
    </div>
    <div class="vx-row mb-2 pt-2">
      <div class="vx-col w-full">
        <label class="label" for="openWebLinkToggle">Open Web Link on Tap</label>
        <vs-switch
          id="openWebLinkToggle"
          color="success"
          v-model="openLinkOnTap"
          @click="message.link = ''"/>
      </div>
    </div>
    <div v-if="openLinkOnTap">
      <div class="vx-row my-2">
        <div class="vx-col w-full">
          <span class="label">If set, the specified URL will open in a web-view inside the iTOVi app.</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input
            label-placeholder="URL (https://www.google.com)"
            v-model="message.link"
            v-on:input="onUpdate"
            class="w-full"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import types from '@/models';
  import { productHelpers } from '@/models/helpers';

  export default {
    data() {
      return {
        loading: false,
        helpers: productHelpers,
        message: new types.ComposePushNotificationMessage(),
        openLinkOnTap: false,
      }
    },
    methods: {
      async onUpdate() {
        this.$emit('messageChanged', this.message);
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
